export default __webpack_public_path__ + "static/media/ig3.8d6be54e.svg";